import { useQuery } from "@tanstack/react-query";
import {
  fetchMarketplaceNextAvailabilities,
  NextAvailabilitiesResponse
} from "PFCore/services/marketplace/fetch_marketplace_next_availabilities";
import { QueryParams } from "PFTypes/query_params";
import { QueryOptions } from "PFTypes/request_options";

import { activitiesKeys } from "../query_keys";

export const useMarketplaceNextAvailabilities = (
  params: QueryParams = { page: 1, perPage: 5 },
  options: QueryOptions<NextAvailabilitiesResponse> = {}
) =>
  useQuery<NextAvailabilitiesResponse>(
    activitiesKeys.nextAvailabilities(params),
    () => fetchMarketplaceNextAvailabilities(params),
    {
      staleTime: 0,
      ...options
    }
  );
